import React, { memo } from "react";
import PropTypes from "prop-types";
import Grid from "@mui/material/Grid2";

import makeStyles from '@mui/styles/makeStyles';

import { Chart } from "./chart.jsx";
import { RateChart } from "./rateChart.jsx";

import RollIcon from "../../../../../assets/images/cargo/load/roll.svg";
import { COLORS } from "../../../../constants/colors.js";
import localizationKeys from "../../../../i18n/localizationKeys.js";
import { useTranslation } from "react-i18next";
import { convertNumber } from "../commonFunc.js";

const useStyles = makeStyles((theme) => ({
  container: {
    width: "100%",
    height: "100%",
  },
  icon: {
    textAlign: "center",
  },
  gauges: {
    display: "flex",
    height: "120px",
  },
  roll: {
    height: "55%",
    display: "flex",
    alignItems: "end",
    justifyContent: "center"
  },
  rate: {
    height: "35%",
  },
  zeroMarker: {
    height: "10%",
    color: COLORS.white,
    textAlign: "center",
    fontSize: "8px",
  },
  details: {
    paddingLeft: "15px",
  },
  table: {
    display: "flex",
    justifyContent: "center",
    fontSize: "14px",
    [theme.breakpoints.up("md")]: {
        gap: "8px",
    },
  },
  row: {
    display: "flex",
    alignItems: "center",
    [theme.breakpoints.down("md")]: {
        justifyContent: "center",
    },
  },
  label: {
      color: COLORS.white,
      width: "60px",
    },
    value: {
        color: COLORS.greenishBlue,
    },
}));

export const Roll = memo((props) => {
  const { data } = props;
  const classes = useStyles();
  const { t } = useTranslation();
  const roll = convertNumber(data[0]?.inputData);
  const rate = convertNumber(data[1]?.inputData);

  return (
    <Grid container className={classes.container} justifyContent="center" alignItems="center">
      <Grid item size={{xs:6, md:4}} className={classes.icon}>
        <img src={RollIcon} width={74} height={41} />
      </Grid>
      <Grid item size={{xs:6, md:4}}>
        <Grid container className={classes.gauges} justifyContent="center" alignItems="center">
          <Grid item size={{xs:12}} className={classes.roll}>
            <Chart roll={roll} />
          </Grid>
          <Grid item size={{xs:12}} className={classes.zeroMarker}>
            0
          </Grid>
          <Grid item size={{xs:12}} className={classes.rate}>
            <RateChart rate={rate} />
          </Grid>
        </Grid>
      </Grid>
      <Grid item size={{xs:12, md:4}} className={classes.details}>
        <Grid container className={classes.table}>
            <Grid item size={{xs: 6, md: 12}} className={classes.row}>
                <div className={classes.label}>Roll</div>
                <div className={classes.value}>{isNaN(roll) ? `${t(localizationKeys.NoLatestData)}.` : `${roll.toFixed(2)} deg`}</div>
            </Grid>
            <Grid item size={{xs: 6, md: 12}} className={classes.row}>
                <div className={classes.label}>{t(localizationKeys.YAngularVelocity)}</div>
                <div className={classes.value}>{isNaN(rate) ? `${t(localizationKeys.NoLatestData)}.` : `${rate.toFixed(2)} deg/s`}</div>
            </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
});

Roll.propTypes = {
  data: PropTypes.array,
};
